module.exports = __webpack_public_path__ + "img/butterflies.3f879a25.png";